//return peakHour color and peackMinute Color
import moment from 'moment'
//input values : 
export function getPeakColor(starttime, startPeakHour,endPeakHour,startPeakMin,endPeakMin,flagPeakH,flagPeakM) {
    var startTime=starttime ? starttime : '00';
    var color1="";
    //color peak hour
    var pkHStart= startPeakHour ? startPeakHour: "--";
    var pkHEnd= endPeakHour ? endPeakHour: "--";
    
    
    var horaInicio = moment(startTime, 'h:mma');
    var startPHMoment = moment(pkHStart, 'h:mma');
    var endtPHMoment = moment(pkHEnd, 'h:mma');
    if(horaInicio.isBefore(endtPHMoment) && horaInicio.isSameOrAfter(startPHMoment)){
      if(flagPeakH){
        color1="#81D3F8";
        
      }else{
        color1="#6EC0E5";
        
      }
      flagPeakH=(!flagPeakH)
    }

    //color  peack minutes startPeakMin endPeakMin
    var pkMStart= startPeakMin ? startPeakMin: "--";
    var pkMEnd= endPeakMin ? endPeakMin: "--";
    var startPMMoment = moment(pkMStart, 'h:mma');
    var endPMMoment = moment(pkMEnd, 'h:mma');
    if(horaInicio.isBefore(endPMMoment) && horaInicio.isSameOrAfter(startPMMoment)){
      if(flagPeakM){
        color1="#F59A23";
        
      }else{
        color1="#E28710";
        
      }
      flagPeakM=(!flagPeakM)
      
    }
    return [color1,flagPeakH,flagPeakM];
}